import { render, staticRenderFns } from "./LaunchDisputeModal.vue?vue&type=template&id=33b6bf03&scoped=true&"
import script from "./LaunchDisputeModal.vue?vue&type=script&lang=js&"
export * from "./LaunchDisputeModal.vue?vue&type=script&lang=js&"
import style0 from "./LaunchDisputeModal.vue?vue&type=style&index=0&id=33b6bf03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6bf03",
  null
  
)

export default component.exports